import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { SortableColumn } from '../model/sort/sortable-column';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';

@Component({
    selector: 'app-electronic-signature-attestation',
    templateUrl: './electronic-signature-attestation.component.html',
    styleUrls: ['./electronic-signature-attestation.component.scss'],
    standalone: false
})
export class ElectronicSignatureAttestationComponent implements OnInit {

  user: UsersDataResponse;
  userData: UserData;

  sortableColumn:SortableColumn;
  constructor(private router: Router, private userservice: UserService) {
      
     this.userservice.getLoginUserData().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      
    })
  }


  ngOnInit(): void {
   
  }

  accept(){
    let nctmAccess=this.userData.nctmAccess;
    this.userservice.updateusa(this.userData.upn).subscribe(sdata=>{
      console.log(sdata);
      this.userservice.getLoginUserData().subscribe(data => {
        this.user = new UsersDataResponse()
        this.user = data;
        this.userData = data.userData
        this.userData.nctmAccess=nctmAccess;
        this.userservice.setCurrentUser(this.user);
        this.router.navigate(['/dcn-esign']);
      })
      
    })

  }

  decline(){
    
    this.userservice.updateLogoutStatus(this.user.userData.sequenceNumber).subscribe(data=>{
      window.location.href = environment.logouturl;
    })
    
  }

}
